import { Link, Navigate, useLocation, useOutletContext } from 'react-router-dom'
import type { TShow } from '@schemas'

export default function LegacySeriesRedirect({ section }: { section: 'reports' | 'alignment' }) {
  const routedShow = useOutletContext<TShow>()
  const location = useLocation()
  const series = routedShow.seriesMembership?.series
  if (!series)
    return (
      <p>
        No readable series is attached to this show.{' '}
        <Link className="underline" to="/show-series">
          Browse show series
        </Link>
      </p>
    )
  return (
    <Navigate
      replace
      to={`/show-series/${series.id}/${section}${location.search}${location.hash}`}
    />
  )
}
